module.exports = __webpack_public_path__ + "static/lasting-clean-logo-diamond-3d4b5279a974880e444b55db6828d966.svg";